// Preset budget categories grouped by spending area
export const BUDGET_GROUPS = ["Essentials", "Lifestyle", "Financial", "Giving", "Other"];

export const CATEGORY_PRESETS = [
  { group: "Essentials", categories: ["Housing", "Groceries", "Utilities", "Transport", "Insurance", "Healthcare", "Phone & Internet", "Childcare"] },
  { group: "Lifestyle", categories: ["Dining", "Entertainment", "Shopping", "Travel", "Fitness", "Personal care", "Hobbies", "Pets"] },
  { group: "Financial", categories: ["Savings", "Investing", "Debt payments", "Emergency fund", "Retirement"] },
  { group: "Giving", categories: ["Charity", "Gifts", "Tithing"] },
];

export const GROUP_META = {
  Essentials: { hint: "Needs — the non-negotiables", tone: "green" },
  Lifestyle: { hint: "Wants — the good life", tone: "gold" },
  Financial: { hint: "Future — savings, investing, debt", tone: "green" },
  Giving: { hint: "Generosity — charity & gifts", tone: "gold" },
  Other: { hint: "Everything else", tone: "muted" },
};
